<div class='RetrevaMinimalLayout'>
  <div class='RetrevaMinimalLayout__header__wrapper'>
    <div class='RetrevaMinimalLayout__header p-4'>
      <div class='RetrevaMinimalLayout__header__logo'>
        <a routerLink='/'
        >
          <img
            alt='Retreva'
            class='RetrevaMinimalLayout__header__logo__desktop'
            height='65'
            src='assets/images/retreva-logo.png'
            width='333'
          />
          <img
            alt='Retreva'
            class='RetrevaMinimalLayout__header__logo__mobile'
            height='63'
            src='assets/images/retreva-icon-alt.png'
            width='63'
          />
        </a>
      </div>
      <div *ngIf='showMenuButtons' class='RetrevaMinimalLayout__header__menu'>
        <app-button
          *ngFor='let button of menuButtons'
          [route]='button.routerLink'
          [text]='button.label'
          color='orange'
          size='small'></app-button>
      </div>
      <div class='RetrevaMinimalLayout__header__bars flex-grow-0'>
        <fa-icon
          (click)='toggleLeftMenu()'
          [icon]='bars'
          [size]="'3x'"
          [styles]='mobileIconStyles'
          class='RetrevaMinimalLayout__header__bars__icon'></fa-icon>
      </div>
    </div>
    <div *ngIf='mobileMenuShown' class='RetrevaMinimalLayout__header__mobile-menu'>
      <app-button
        *ngFor='let button of menuButtons'
        [color]='button.color'
        [route]='button.routerLink'
        [text]='button.label'
        size='big'></app-button>
    </div>
  </div>
  <div class='RetrevaMinimalLayout__content'>
    <router-outlet></router-outlet>
  </div>
  <div class='RetrevaMinimalLayout__footer'>
    <app-authenticated-footer></app-authenticated-footer>
  </div>
</div>
